<template>
  <div class="new-more">
    <van-list :immediate-check="false" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div @click="handle2Detail(item)" class="item" v-for="item in list" :key="item.newsInfoId">
        <img src="@/assets/image/home/notice.png" alt="" />
        <div class="detail">
          <div class="title van-multi-ellipsis--l2">{{ item.newsInfoTitle }}</div>
          <div>
            <span class="auth">{{ item.newsInfoCreateUserName }}</span>
            <span class="time">{{ item.newsInfoCreateTime | formatDate('MM-dd') }}</span>
          </div>
        </div>
      </div>
    </van-list>
    <!-- <Back /> -->
  </div>
</template>

<script>
import {getNoticeList} from '@/api'
export default {
  data() {
    return {
      totalDatas: 0,
      pageNo: 1,
      pageSize: 20,
      loading: false,
      finished: false,
      list: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    async onLoad() {
      if (this.pageNo >= Math.ceil(this.totalDatas / this.pageSize)) {
        this.finished = true
        return
      }
      this.pageNo = this.pageNo + 1
      await this.init()
      this.loading = false
    },
    init() {
      const params = {
        type: 2,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      getNoticeList(params).then(res => {
        if (res.code === 0) {
          this.totalDatas = res.totalDatas * 1
          this.list = [...this.list, ...res.data]
        }
      })
    },
    handle2Detail(item) {
      this.$router.push(`/new/${item.newsInfoId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.new-more {
}
.item {
  padding: 12px 16px 0;
  background: #fff;
  display: flex;
  img {
    width: 40px;
    height: 40px;
    margin-right: 16px;
  }
  div.detail {
    border-bottom: 1px solid #f3f3f3;
    padding-bottom: 12px;
    flex: 1;
    .title {
      color: #222222;
      font-weight: 500;
      font-size: 15px;
      // padding-bottom: 10px;
    }
    .auth,
    .time {
      color: #888888;
      font-size: 13px;
      margin-right: 18px;
    }
  }
}
</style>
